"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = void 0;
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var css_1 = require("@emotion/css");
var react_1 = __importStar(require("react"));
var tabCss = function (isSelected, selectedTheme) { return (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  color: ", ";\n  border: none;\n  background-color: unset;\n  cursor: pointer;\n\n  :hover:not([data-selected=\"true\"], :disabled) {\n    color: ", ";\n  }\n\n  :focus-visible {\n    text-decoration: underline;\n    outline: unset;\n  }\n\n  :disabled {\n    color: ", ";\n    cursor: not-allowed;\n  }\n"], ["\n  ", "\n  color: ", ";\n  border: none;\n  background-color: unset;\n  cursor: pointer;\n\n  :hover:not([data-selected=\"true\"], :disabled) {\n    color: ", ";\n  }\n\n  :focus-visible {\n    text-decoration: underline;\n    outline: unset;\n  }\n\n  :disabled {\n    color: ", ";\n    cursor: not-allowed;\n  }\n"])), (0, design_system_foundations_1.expandFontTheme)(isSelected ? (0, design_system_foundations_1.addFontThemePrefix)(selectedTheme, 'bodyStrong') : (0, design_system_foundations_1.addFontThemePrefix)(selectedTheme, 'body')), (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: design_system_foundations_1.theme.color.black, dark: design_system_foundations_1.darkTheme.color.white }), (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: design_system_foundations_1.theme.color.turquoise90, dark: design_system_foundations_1.darkTheme.color.teal100 }), design_system_foundations_1.theme.color.neutral50); };
var determineAccessibleProps = function (value) {
    var tabPanel = document.getElementById("tabpanel-".concat(value));
    return {
        id: "tab-".concat(value),
        'aria-controls': tabPanel ? "tabpanel-".concat(value) : undefined, // support rendering with and without tab panels
    };
};
var validateValue = function (value) {
    if (!document.getElementById("tabpanel-".concat(value))) {
        console.warn('Tab value prop does not match any TabPanel value prop');
    }
};
var Tab = function (_a) {
    var value = _a.value, tabListValue = _a.tabListValue, onClick = _a.onClick, label = _a.label, tabRef = _a.tabRef, onRender = _a.onRender, testId = _a.testId, isDisabled = _a.isDisabled, className = _a.className, props = __rest(_a, ["value", "tabListValue", "onClick", "label", "tabRef", "onRender", "testId", "isDisabled", "className"]);
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    var isSelected = value === tabListValue;
    (0, react_1.useLayoutEffect)(function () {
        validateValue(value);
        if (onRender) {
            onRender();
        }
    }, [onRender, value]);
    return (react_1.default.createElement("button", __assign({}, props, { disabled: isDisabled, type: "button", role: "tab", "aria-selected": isSelected, "data-selected": isSelected, "data-testid": testId, onClick: !isSelected ? onClick : undefined, className: (0, css_1.cx)(tabCss(isSelected, selectedTheme), className, 'ds-tab'), tabIndex: isSelected ? 0 : -1 }, determineAccessibleProps(value), { ref: tabRef }), label));
};
exports.Tab = Tab;
exports.Tab.displayName = 'Tab';
var templateObject_1;
